import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

enum Locale {
  FRENCH = 'fr',
  SPANISH = 'es',
  ENGLISH = 'en',
  ENGLISH_GB = 'en-GB',
  DUTCH = 'nl',
  GERMAN = 'de',
}

@Injectable({ providedIn: 'root' })
export class PhxTranslationService {
  public locale: string = 'en';

  constructor(private translateService: TranslocoService) { }

  public setDefaultLocale(): void {
    this.locale = navigator.language || 'en';
    this.translateService.setActiveLang(this.locale);
  }

  public setLocale(userLang: string): void {
    switch (userLang) {
      case 'fr-CA':
        this.locale = Locale.FRENCH;
        break;
      case 'es-MX':
        this.locale = Locale.SPANISH;
        break;
      case 'nl-NL':
        this.locale = Locale.DUTCH;
        break;
      case 'de-DE':
        this.locale = Locale.GERMAN;
        break;
      case 'en-GB':
        this.locale = Locale.ENGLISH_GB;
        break;
      default:
        this.locale = Locale.ENGLISH;
        break;
    }

    this.translateService.setActiveLang(this.locale);
  }

  public getLocale(): string {
    return this.locale;
  }
}
